/**
 * 轮询
 * @param {*} promiseMaker function, 执行返回一个promise
 * @param {*} callback 请求的回调
 * @param {*} maxAttempts 最大尝试次数
 * @param {*} interval 间隔
 */
export function pollFetch(promiseMaker, callback, maxAttempts = 100, interval = 3000) {
  let attempts = 0;
  let stopPolling = false;
  let timer = null;

  function pollAgain() {
    if (stopPolling) {
      return;
    }

    attempts++;
    promiseMaker()
      .then((res) => {
        if (callback(res)) {
          stopPolling = true;
          clearTimeout(timer);
          return;
        }

        if (maxAttempts && attempts >= maxAttempts) {
          clearTimeout(timer);
          return;
        }

        timer = setTimeout(pollAgain, interval);
      })
      .catch((error) => console.error(error));
  }

  // 提供给外层清除定时器的方法
  pollFetch.clearTimer = () => {
    clearTimeout(timer);
  };

  pollAgain();
}
